import { userStatus } from "../../../constants/user";
import { IChipProps } from "../../../types/common/chips";
import "./Chips.css";

const colorScheme = {
  [userStatus.DRAFTED]: "drafted",
  [userStatus.SUBMITTED]: "submitted",
  [userStatus.APPROVED]: "approved",
  [userStatus.REJECTED]: "rejected",
  [userStatus.ADMITTED]: "admitted",
  [userStatus.NOT_ADMITTED]: "not-admitted",
  [userStatus.QUERY_RAISED]: "advised_medical", //new one
  // [userStatus.CONSULTANT_DONE]: "consultant",
  // [userStatus.ADVICED_DIAGNOSTICS]: "advised_diagnostics",
  // [userStatus.ADVICED_ADMISSION]: "advised_admission",
  // [userStatus.TREATED_SUCCESSFULLY]: "treated",
  // [userStatus.DISCHARGES_WITH_MEDICAL_MANAGEMENT]:
  //   "discharged_medical",
  // [userStatus.DISCHARGES_FOR_FOLLOW_UP_TREATMENT]:
  //   "discharged_followup",
  [userStatus.ESTIMATE_APPROVAL_REQUEST]: "estimate-approval-request",
  [userStatus.ESTIMATE_APPROVED]: "estimate-approved",
  [userStatus.ESTIMATE_QUERY_RAISED]: "query-raised",
  [userStatus.ENHANCE_APPROVAL_REQUEST]: "enhance-approval-request",
  [userStatus.ENHANCE_APPROVED]: "enhance-approved",
  [userStatus.QUERY_RAISED_ON_ENHANCE]: "query-raised",
  [userStatus.EXPIRED]: "expired",
  [userStatus.DISCHARGED]: "discharged_medical",
  [userStatus.LAMA]: "lama",
  [userStatus.FOLLOW_UP_ONE]: "followup",
  [userStatus.FOLLOW_UP_THREE]: "followup",
  [userStatus.FOLLOW_UP_SEVEN]: "followup",
  [userStatus.FOLLOW_UP_FIFTEEN]: "followup",
  [userStatus.CLOSED]: "closed",
};

const Chip = (props: IChipProps) => {
  const { className, label, ...rest } = props;
  let { color = "default", extension = "" } = props;

  return (
    <div
      className={`chips chip-${colorScheme[label] || color} ${
        className ? className : ""
      }`}
      {...rest}
    >
      {label?.replaceAll("_", " ")}
      {extension && <span className="chip-extension">{extension}</span>}
    </div>
  );
};

export default Chip;
